firebird.factory('cookieService', [
    '$cookies',
    function ($cookies) {
        var service = {
            get: get,
            getObject: getObject,
            put: put,
            putObject: putObject,
            remove: remove
        };

        return service;

        ////////////////////////

        function get(key) {
            return $cookies.get(key);
        }

        function getObject(key) {
            return $cookies.getObject(key);
        }

        function put(key, value, options) {
            options = ensureRequiredOptions(options);
            $cookies.put(key, value, options);
        }

        function putObject(key, value, options) {
            options = ensureRequiredOptions(options);
            $cookies.putObject(key, value, options);
        }

        function remove(key) {
            return $cookies.remove(key);
        }

        function ensureRequiredOptions(options) {
            if (!options) {
                options = {
                    samesite: 'strict'
                };
            } else if (!options.samesite) {
                options.samesite = 'strict';
            }

            options.secure = true;

            return options;
        }
    }
]);
